import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Tabs, message } from 'antd';
import Import from '../../../../../../../components/Import/Import';
import { downloadOnboardingUsersImportTemplate, parseOrgUsersImportResult } from '../../../../../../Onboarding/onboardingApi';
import { createOrgUserInvitee } from '../../../../Broker/BrokerActions';
import { MSG_ERROR } from '../../../../../../../constants';
import { getApiErrorMessage } from '../../../../../../../utils/httpError';
import ManualAddUserForm from './ManualAddUserForm';

const { TabPane } = Tabs;

const IMPORT_UPLOAD_HINT =
  'Download the template first, fill in Email, First Name, and Last Name, then add any optional business or plan details before uploading the completed file here.';

function AddUsersModal({
  brokerageId,
  createOrgUserInvitee,
  onStaged,
  importSubscriptions,
  onImportComplete,
  importResult = null,
}) {
  const [addingUser, setAddingUser] = useState(false);

  const handleImport = async (formData) => importSubscriptions(brokerageId, formData);

  const handleManualAddUser = async (data) => {
    setAddingUser(true);
    try {
      const result = await createOrgUserInvitee(data);

      if (onStaged) {
        await onStaged(result);
      }

      return result;
    } catch (err) {
      message.error(err?.isUserFacing ? err.message : getApiErrorMessage(err, MSG_ERROR));
      throw err;
    } finally {
      setAddingUser(false);
    }
  };

  return (
    <Tabs defaultActiveKey="import" className="add-users-tabs">
      <TabPane tab="Import file" key="import">
        <p className="add-users-tab-note">
          <strong>How to import users</strong>
        </p>
        <ol className="add-users-import-steps">
          <li>Download the template using the button below.</li>
          <li>
            Fill in the required columns: <strong>Email</strong>, <strong>First Name</strong>, and{' '}
            <strong>Last Name</strong>.
          </li>
          <li>
            Optional columns: <strong>Business Name</strong>, <strong>Trading Name</strong>,{' '}
            <strong>Business Registration Number</strong>, <strong>Plan Name</strong>, and <strong>Currency</strong>.
          </li>
          <li>Upload the completed file.</li>
          <li>Review staged users on the Subscription Onboarding tab, then send invites when you are ready.</li>
        </ol>
        <Import
          templateName="broker-import-users-template.xlsx"
          downloadTemplate={downloadOnboardingUsersImportTemplate}
          importFromTemplate={handleImport}
          parseImportResult={parseOrgUsersImportResult}
          persistedImportResult={importResult}
          onImportComplete={onImportComplete}
          uploadHint={IMPORT_UPLOAD_HINT}
        />
      </TabPane>
      <TabPane tab="Add manually" key="manual">
        <p className="add-users-tab-note">
          Enter user details below. The user will be staged on the Subscription Onboarding tab — send the invite when
          you are ready. No email is sent at this step.
        </p>
        <ManualAddUserForm loading={addingUser} onAdd={handleManualAddUser} />
      </TabPane>
    </Tabs>
  );
}

const mapDispatchToProps = { createOrgUserInvitee };

export default connect(null, mapDispatchToProps)(AddUsersModal);
